/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
// import questionImg from "assets/img/self/question.png";
import ball from "assets/img/ball.png";
import redball from "assets/img/redball.png";

import { useHistory } from 'react-router-dom';
import Modal from 'react-modal';
// reactstrap components

import NotificationAlert from "react-notification-alert";
import {  
  Card,  
  CardBody,
  CardTitle,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

import face1 from "assets/img/face/1.png";
import face2 from "assets/img/face/2.png";
import face3 from "assets/img/face/3.png";
import face4 from "assets/img/face/4.png";
import face5 from "assets/img/face/5.png";

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
let selTables = {};
let session;
let notificationAlert;
let selTab = {};
let se;
var aTimeout = null;

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding:'0.25rem',
    width:'85%',
    borderRadius:'15px',
    fontWeight:'bold'
  },
};

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

let ff = 0;

function Tablesedit() {

  session = window.sessionStorage.getItem('sessions'); 
  // selTab = {};
    
  if(session === null){    
    window.location = '/';
  }

  se = JSON.parse(session);

  notificationAlert = React.useRef(); 

  selTables = JSON.parse(window.sessionStorage.getItem('selTables'));

  const history = useHistory();
  // const [modalIsOpen, setIsOpen]    = useState(false);
  const [disabled, setDisabled] = useState('');

  const removeTablesData = (e) => {
    ff = 1;
    setIsComModal(true);
    setDisabled('disabled');
  }
  
  const preparationPage = (e) => {   
    history.push('../admin/tables');
  }
///////////////////
  const [resthink1, setResthink1] = useState();
  const [resthink2, setResthink2] = useState();
  const [resthink3, setResthink3] = useState();
  const [resthink4, setResthink4] = useState();
  const [resthink5, setResthink5] = useState();

  const getInputResthink1Value = (event)=>{    
    setResthink1(event.target.value);     
    selTab['resthink1'] = event.target.value;
  };
  const getInputResthink2Value = (event)=>{    
    setResthink2(event.target.value);     
    selTab['resthink2'] = event.target.value;
  };
  const getInputResthink3Value = (event)=>{    
    setResthink3(event.target.value);     
    selTab['resthink3'] = event.target.value;
  };
  const getInputResthink4Value = (event)=>{    
    setResthink4(event.target.value);     
    selTab['resthink4'] = event.target.value;
  };
  const getInputResthink5Value = (event)=>{    
    setResthink5(event.target.value);     
    selTab['resthink5'] = event.target.value;
  };

  const [offort, setOffort] = useState();
  const [fight, setFight] = useState();
  const getInputOffortValue = (event)=>{    
    setOffort(event.target.value);     
    selTab['offort'] = event.target.value;
  };
  const getInputFightValue = (event)=>{    
    setFight(event.target.value);     
    selTab['fight'] = event.target.value;
  };
  /////////////////////// start //////////////////////
  const [g1_1, setg1_1] = useState(0);
  const [g1_2, setg1_2] = useState(0);
  const [g1_3, setg1_3] = useState(0);
  const [g1_4, setg1_4] = useState(0);
  const [g1_5, setg1_5] = useState(0);
  const [g1_6, setg1_6] = useState(0);
  const [g1_7, setg1_7] = useState(0);
  const [g1_8, setg1_8] = useState(0);
  const [g1_9, setg1_9] = useState(0);
  const [g1_10, setg1_10] = useState(0);
  const [g1_11, setg1_11] = useState(0);
  const [g1_12, setg1_12] = useState(0);
  const [g1_13, setg1_13] = useState(0);
  const [g1_14, setg1_14] = useState(0);
  const [g1_15, setg1_15] = useState(0);
  const [g1_16, setg1_16] = useState(0);
  const [g1_17, setg1_17] = useState(0);

  const [_g1_1, set_g1_1] = useState(0);
  const [_g1_2, set_g1_2] = useState(0);
  const [_g1_3, set_g1_3] = useState(0);
  const [_g1_4, set_g1_4] = useState(0);
  const [_g1_5, set_g1_5] = useState(0);
  const [_g1_6, set_g1_6] = useState(0);
  const [_g1_7, set_g1_7] = useState(0);
  const [_g1_8, set_g1_8] = useState(0);
  const [_g1_9, set_g1_9] = useState(0);
  const [_g1_10, set_g1_10] = useState(0);
  const [_g1_11, set_g1_11] = useState(0);
  const [_g1_12, set_g1_12] = useState(0);
  const [_g1_13, set_g1_13] = useState(0);
  const [_g1_14, set_g1_14] = useState(0);
  const [_g1_15, set_g1_15] = useState(0);
  const [_g1_16, set_g1_16] = useState(0);
  const [_g1_17, set_g1_17] = useState(0);

  const [g2_1, setg2_1] = useState(0);
  const [g2_2, setg2_2] = useState(0);
  const [g2_3, setg2_3] = useState(0);
  const [g2_4, setg2_4] = useState(0);
  const [g2_5, setg2_5] = useState(0);
  const [g2_6, setg2_6] = useState(0);
  const [g2_7, setg2_7] = useState(0);
  const [g2_8, setg2_8] = useState(0);
  const [g2_9, setg2_9] = useState(0);
  const [g2_10, setg2_10] = useState(0);
  const [g2_11, setg2_11] = useState(0);
  const [g2_12, setg2_12] = useState(0);
  const [g2_13, setg2_13] = useState(0);
  const [g2_14, setg2_14] = useState(0);
  const [g2_15, setg2_15] = useState(0);
  const [g2_16, setg2_16] = useState(0);
  const [g2_17, setg2_17] = useState(0);

  const [_g2_1, set_g2_1] = useState(0);
  const [_g2_2, set_g2_2] = useState(0);
  const [_g2_3, set_g2_3] = useState(0);
  const [_g2_4, set_g2_4] = useState(0);
  const [_g2_5, set_g2_5] = useState(0);
  const [_g2_6, set_g2_6] = useState(0);
  const [_g2_7, set_g2_7] = useState(0);
  const [_g2_8, set_g2_8] = useState(0);
  const [_g2_9, set_g2_9] = useState(0);
  const [_g2_10, set_g2_10] = useState(0);
  const [_g2_11, set_g2_11] = useState(0);
  const [_g2_12, set_g2_12] = useState(0);
  const [_g2_13, set_g2_13] = useState(0);
  const [_g2_14, set_g2_14] = useState(0);
  const [_g2_15, set_g2_15] = useState(0);
  const [_g2_16, set_g2_16] = useState(0);
  const [_g2_17, set_g2_17] = useState(0);

  const [g3_1, setg3_1] = useState(0);
  const [g3_2, setg3_2] = useState(0);
  const [g3_3, setg3_3] = useState(0);
  const [g3_4, setg3_4] = useState(0);
  const [g3_5, setg3_5] = useState(0);
  const [g3_6, setg3_6] = useState(0);
  const [g3_7, setg3_7] = useState(0);
  const [g3_8, setg3_8] = useState(0);
  const [g3_9, setg3_9] = useState(0);
  const [g3_10, setg3_10] = useState(0);
  const [g3_11, setg3_11] = useState(0);
  const [g3_12, setg3_12] = useState(0);
  const [g3_13, setg3_13] = useState(0);
  const [g3_14, setg3_14] = useState(0);
  const [g3_15, setg3_15] = useState(0);
  const [g3_16, setg3_16] = useState(0);
  const [g3_17, setg3_17] = useState(0);


  const [_g3_1, set_g3_1] = useState(0);
  const [_g3_2, set_g3_2] = useState(0);
  const [_g3_3, set_g3_3] = useState(0);
  const [_g3_4, set_g3_4] = useState(0);
  const [_g3_5, set_g3_5] = useState(0);
  const [_g3_6, set_g3_6] = useState(0);
  const [_g3_7, set_g3_7] = useState(0);
  const [_g3_8, set_g3_8] = useState(0);
  const [_g3_9, set_g3_9] = useState(0);
  const [_g3_10, set_g3_10] = useState(0);
  const [_g3_11, set_g3_11] = useState(0);
  const [_g3_12, set_g3_12] = useState(0);
  const [_g3_13, set_g3_13] = useState(0);
  const [_g3_14, set_g3_14] = useState(0);
  const [_g3_15, set_g3_15] = useState(0);
  const [_g3_16, set_g3_16] = useState(0);
  const [_g3_17, set_g3_17] = useState(0);

  const[win1, setwin1] = useState(0);
  const[lose1, setlose1] = useState(0);
  const[win2, setwin2] = useState(0);
  const[lose2, setlose2] = useState(0);
  const[win3, setwin3] = useState(0);
  const[lose3, setlose3] = useState(0);

  const onGameSetComment = (e, f) => {
    return;
    setIsComModal(true);
    setComment(comlist[f] || '');
    setTname(f);
  }

  const handleOnChange = (e, position, r)=>{   
    if(aTimeout)
      clearTimeout(aTimeout);   
    let f = eval(position);
    let l = eval("_"+position);

    // console.log(f);
    setTname(position);
    if(f == 0){
      // setIsComModal(true);
      setComment(comlist[position] || '');
      // onEditSelectedItem(e, position, r);
      let comments = comlist;
      comments[position] = '';
      setComlist(comments);
      axios.get(URL_API+"setTablesComment", {
        params: {
          user_id: se['id'],
          p_id: selTables['id'], 
          tname:position,
          comment:''
        }
      })
      .then(function (response) {
        setUSFlag((c) => c + 1);
      });
    }else{
      let comments = comlist;
      comments[position] = '';
      setComlist(comments);
      axios.get(URL_API+"setTablesComment", {
        params: {
          user_id: se['id'],
          p_id: selTables['id'], 
          tname:position,
          comment:''
        }
      })
      .then(function (response) {
        setUSFlag((c) => c + 1);
      });
    }
    f = Number(!f);
    l = f == 1 ? 0 : l;

    eval("set"+position)(f);
    eval("set_"+position)(l);
    selTab[position] = f;
    selTab["_"+position] = l;

    selTab["win"+r] = 0;
    selTab["lose"+r] = 0;

    eval("setwin"+r)(0);
    eval("setlose"+r)(0);

    for(var i = 1; i < 18; i++){

      if(eval(selTab["g"+r+"_"+i]) == 1){
        
        selTab["win"+r] = selTab["win"+r] + 1;
      }
      if(eval(selTab["_g"+r+"_"+i]) == 1){
        selTab["lose"+r] = selTab["lose"+r] + 1;
      }
    }
    eval("setwin"+r)(selTab["win"+r]);
    eval("setlose"+r)(selTab["lose"+r]);    
  };

  const _handleOnChange = (e, position, r)=>{
    if(aTimeout)
      clearTimeout(aTimeout);  
    setTname("_"+position);
    let f = eval(position);
    let l = eval("_"+position);

    if(l == 0){
      // setIsComModal(true);
      setComment(comlist["_"+position] || '');
      // onEditSelectedItem(e, position, r);
      let comments = comlist;
      comments[position] = '';
      setComlist(comments);
      axios.get(URL_API+"setTablesComment", {
        params: {
          user_id: se['id'],
          p_id: selTables['id'], 
          tname:position,
          comment:''
        }
      })
      .then(function (response) {
        setUSFlag((c) => c + 1);
      });
    }else{
      let comments = comlist;
      comments["_"+position] = '';
      setComlist(comments);
      axios.get(URL_API+"setTablesComment", {
        params: {
          user_id: se['id'],
          p_id: selTables['id'], 
          tname:"_"+position,
          comment:''
        }
      })
      .then(function (response) {
        setUSFlag((c) => c + 1);
      });
    }
    l = Number(!l);
    f = l == 1 ? 0 : f;

    eval("setwin"+r)(0);
    eval("setlose"+r)(0);
    
    eval("set_"+position)(l);
    eval("set"+position)(f);
    selTab[position] = f;
    selTab["_"+position] = l;

    selTab["win"+r] = 0;
    selTab["lose"+r] = 0;

    for(var i = 1; i < 18; i++){
      if(eval(selTab["g"+r+"_"+i]) == 1){
        selTab["win"+r] = selTab["win"+r] + 1;
      }
      if(eval(selTab["_g"+r+"_"+i]) == 1){
        selTab["lose"+r] = selTab["lose"+r] + 1;
      }
    }
    eval("setwin"+r)(selTab["win"+r]);
    eval("setlose"+r)(selTab["lose"+r]);
    // setIsComModal(true);
  };

  ////////////////////////////////////////////////////
  const [improved1, setImproved1] = useState();
  const getInputImproved1Value = (event)=>{    
    setImproved1(event.target.value);     
    selTab['improved1'] = event.target.value;
  };
  const [improved2, setImproved2] = useState();
  const getInputImproved2Value = (event)=>{    
    setImproved2(event.target.value);     
    selTab['improved2'] = event.target.value;
  };
  const [improved3, setImproved3] = useState();
  const getInputImproved3Value = (event)=>{    
    setImproved3(event.target.value);     
    selTab['improved3'] = event.target.value;
  };
  const [improved4, setImproved4] = useState();
  const getInputImproved4Value = (event)=>{    
    setImproved4(event.target.value);     
    selTab['improved4'] = event.target.value;
  };
  const [improved5, setImproved5] = useState();
  const getInputImproved5Value = (event)=>{    
    setImproved5(event.target.value);     
    selTab['improved5'] = event.target.value;
  };
  //HowPlay
  const [howplay1, setHowplay1] = useState();
  const getInputHowplay1Value = (event)=>{    
    setHowplay1(event.target.value);     
    selTab['howplay1'] = event.target.value;
  };
  const [howplay2, setHowplay2] = useState();
  const getInputHowplay2Value = (event)=>{    
    setHowplay2(event.target.value);     
    selTab['howplay2'] = event.target.value;
  };
  const [howplay3, setHowplay3] = useState();
  const getInputHowplay3Value = (event)=>{    
    setHowplay3(event.target.value);     
    selTab['howplay3'] = event.target.value;
  };
  const [howplay4, setHowplay4] = useState();
  const getInputHowplay4Value = (event)=>{    
    setHowplay4(event.target.value);     
    selTab['howplay4'] = event.target.value;
  };
  const [howplay5, setHowplay5] = useState();
  const getInputHowplay5Value = (event)=>{    
    setHowplay5(event.target.value);     
    selTab['howplay5'] = event.target.value;
  };

  const [mental1, setMental1] = useState();
  const [mental2, setMental2] = useState();
  const [mental3, setMental3] = useState();
  const [mental4, setMental4] = useState();
  const [mental5, setMental5] = useState();
  const [mental6, setMental6] = useState();
  const [mental7, setMental7] = useState();
  const [mental8, setMental8] = useState();
  const [mental9, setMental9] = useState();
  const [mental10, setMental10] = useState();
  const [mental11, setMental11] = useState();
  const [mental12, setMental12] = useState();

  const getInputMental1Value = (event, f)=>{    
    setMental1(f);     
    selTab['mental1'] = f;
  };
  const getInputMental2Value = (event, f)=>{    
    setMental2(f);     
    selTab['mental2'] = f;
  };
  const getInputMental3Value = (event, f)=>{    
    setMental3(f);     
    selTab['mental3'] = f;
  };
  const getInputMental4Value = (event, f)=>{    
    setMental4(f);     
    selTab['mental4'] = f;
  };
  const getInputMental5Value = (event, f)=>{    
    setMental5(f);     
    selTab['mental5'] = f;
  };
  const getInputMental6Value = (event, f)=>{    
    setMental6(f);     
    selTab['mental6'] = f;
  };
  const getInputMental7Value = (event, f)=>{    
    setMental7(f);     
    selTab['mental7'] = f;
  };
  const getInputMental8Value = (event, f)=>{    
    setMental8(f);     
    selTab['mental8'] = f;
  };
  const getInputMental9Value = (event, f)=>{    
    setMental9(f);     
    selTab['mental9'] = f;
  };
  const getInputMental10Value = (event, f)=>{    
    setMental10(f);     
    selTab['mental10'] = f;
  };
  const getInputMental11Value = (event, f)=>{    
    setMental11(f);     
    selTab['mental11'] = f;
  };
  const getInputMental12Value = (event, f)=>{    
    setMental12(f);     
    selTab['mental12'] = f;
  };

  const [remark, setRemark] = useState();
  const getInputRemarkValue = (event)=>{    
    setRemark(event.target.value);     
    selTab['remark'] = event.target.value;
  };
///////////////////
  const [checkboxgroup, setCheckboxgroup] = useState(
    [ { en: 's_serverData', jp: 'サーブ', fc: 's_setServerData', val:true },
      { en: 's_receiveData', jp: 'レシーブ', fc: 's_setReceiveData', val:true},
      { en: 's_strokeData', jp: 'ストローク', fc: 's_setStrokeData', val:true},
      { en: 's_netplayData', jp: 'ネットプレー', fc: 's_setNetplayData', val:true},
      { en: 's_mentalData', jp: 'メンタル', fc: 's_setMentalData', val:true},
      { en: 's_tacticsData', jp: '戦術', fc: 's_setTacticsData', val:true},]
    );

  const [s_serverData, s_setServerData] = useState([]);
  const [s_receiveData, s_setReceiveData] = useState([]);
  const [s_strokeData, s_setStrokeData] = useState([]);
  const [s_netplayData, s_setNetplayData] = useState([]);
  const [s_mentalData, s_setMentalData] = useState([]);
  const [s_tacticsData, s_setTacticsData] = useState([]);
  
  const [checkedState, setCheckedState] = useState(
    new Array(s_serverData.length).fill(false)
  );
  
  const profileUpdateFunc = (e) => {

    window.sessionStorage.setItem("other", selTables['id']);
    history.push('../sub/other');
  }

  const analysisOnChange = (e, position, aryName, fcName) => {
    
    eval(aryName)[position]['solution'] = e.target.value;
    window.sessionStorage.setItem(aryName, JSON.stringify(eval(aryName))); 
    eval(fcName)(eval(aryName));

    let tmp = [...checkboxgroup];
    tmp[0]['val'] = !tmp[0]['val'];
    setCheckboxgroup(tmp);

  };
  const [coachs, setCoachs] = useState(JSON.parse(window.sessionStorage.getItem('coachs')));
  const onSendMsg = (e, pid) => {
    // console.log(pid);
    // if(window.confirm("試合後リフレクションの内容をコーチに送信しますか？")){
      // for(let i=0;i<coachs.length;i++){
        axios.get(URL_API+"setMessagesT", {
          params: {
            // coach_id : coachs[i]['id'],
            player_id : se['id'],
            // content : '<p>'+se['name']+'選手様からメッセージが来ました。</p><p>"'+selTables['tournament']+' '+selTables['tourdate']+' '+selTables['opponentgroup']+' '+selTables['opponentname']+'"</p>',
            content : '<p>リフレクションデータが届きました。</p><p>"'+selTables['tournament']+' '+selTables['tourdate']+' '+selTables['opponentgroup']+' '+selTables['opponentname']+'"</p>',
            t : pid,
            f : 0
          }
        })
        .then(function (response) {
          // setUFlag(uFlag+1);
          // setMsg('');
          setDisabled('');
          var options = {};
          var color = Math.floor(Math.random() * 5 + 1);
          var type;
          switch (color) {
            case 1:
              type = "primary";
              break;
            case 2:
              type = "success";
              break;
            case 3:
              type = "danger";
              break;
            case 4:
              type = "warning";
              break;
            case 5:
              type = "info";
              break;
            default:
              break;
          }
          options = {
            place: "tc",
            message: (
              <div>
                <div>
                  転送されました。
                </div>
              </div>
            ),
            type: type,
            icon: "nc-icon nc-bell-55",
            autoDismiss: 7,
          };
          notificationAlert.current.notificationAlert(options);
        }).catch(
          error => {
            if(error.response){
              console.log(error.response.data);
            };
          }
        ); 
      // }
    // }else{
    //   setDisabled('');
    // }
  }

  const sendPreparationData = (e, f) => {
    tablesUpdateFunc(e, f);
  }

  const tablesUpdateFunc = (e, f) => {
    var color = Math.floor(Math.random() * 5 + 1);
    var type;
    switch (color) {
      case 1:
        type = "primary";
        break;
      case 2:
        type = "success";
        break;
      case 3:
        type = "danger";
        break;
      case 4:
        type = "warning";
        break;
      case 5:
        type = "info";
        break;
      default:
        break;
    }
     
    var data = JSON.stringify(selTab);
    // console.log(selTab);
    setDisabled('disabled');
    axios.get(URL_API+"tablesUpdateAPI", {
      params: {
        data: data, 
        user_id: selTables["proposer"],
        sel: selTables["id"],
      }
    })
    .then(function (response) {    
      if(f == 1){
        // console.log(response.data.id);
        onSendMsg(e, selTables['id']);
        return;
      }
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <div>
              <b>「試合後リフレクション画面編集」</b>が 完了しました。
            </div>
          </div>
        ),
        type: type,
        icon: "nc-icon nc-bell-55",
        autoDismiss: 7,
      };
      setDisabled('');
      notificationAlert.current.notificationAlert(options);
    })
  }
  
  const [comment, setComment] = useState('');
  const [isComModal, setIsComModal]   = useState(false);
  const [tname, setTname] = useState('');
  const [uSFlag, setUSFlag] = useState(0);
  // const [ff, setFF] = useState(0);

  function afterOpenModal() {
    ff = 0;
  }

  function closeModal() {
    setIsComModal(false);
    setDisabled('');
  }

  const onRemoveSelItem = (event) => {    
    // console.log(selTables);
    axios.get(URL_API+"deleteTablesData", {
      params: {
        id: selTables.id, 
        pre_id:selTables.items.pre_id,
        sel: se['id'], 
      }
    })
    .then(function (response) {      
      setIsComModal(false);
      setDisabled('');
      history.push('../admin/tables');
    });
  }

  const onChangeComment = (e) => {
    setComment(e.target.value);
    let comments = comlist;
    if(aTimeout)
      clearTimeout(aTimeout);

    aTimeout = setTimeout(function(){
      comments[tname] = e.target.value;
      setComlist(comments);
      axios.get(URL_API+"setTablesComment", {
        params: {
          user_id: se['id'],
          p_id: selTables['id'], 
          tname:tname,
          comment:e.target.value
        }
      })
      .then(function (response) {
        setUSFlag((c) => c + 1);
      });
    }, 500);
  }

  const onEditSelectedItem= (e, position, r) => {
    // return;
    setTname(position);
    let f = eval(position);
    // console.log(f);
    if(f == 0)
      return;
    aTimeout = setTimeout(function(){
      axios.get(URL_API+"getTablesComment", {
        params: {
          user_id: se['id'],
          p_id: selTables['id'], 
          tname:position
        }
      })
      .then(function (response) {

        setComment(response.data);

      });
      setIsComModal(true);
    }, 1500);
    return false;
  }

  const onEditSelectedItem1 = (e, position, r) => {
    // return;    
    if(window.mobileCheck())
      return;
    onEditSelectedItem(e, position, r);
  }

  let arrays = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17];

  const [comlist, setComlist] = useState([]);

  useEffect(() => {  
    

    //戦術
    selTab = {};
    selTab["lose1"] = 0;
    selTab["win1"] = 0;
    selTab["lose2"] = 0;
    selTab["win2"] = 0;
    selTab["lose3"] = 0;
    selTab["win3"] = 0;

    for(var i = 0 ; i < checkboxgroup.length; i++){

      axios.get(URL_API+"getOtherSelAPI", {
        params: {
          data: checkboxgroup[i]['en'],
          sel: selTables['id'], 
        }
      })
      .then(function (response) {
        
        if(response.data.length > 0 && Array.isArray(response.data)){           
          eval(response.data[0]['fc'])(response.data);  
        }

      });
    }

    //selGame. selTables

    axios.get(URL_API+"getTablesCommentList", {
      params: {
        user_id: se["id"],
        p_id: selTables['id'],
      }
    })
    .then(function (response) {    
      setComlist(response.data);
    })

    axios.get(URL_API+"getSelTableAPI", {
      params: {       
        sel: selTables['id'], 
      }
    })
    .then(function (response) {
      
      window.sessionStorage.setItem('selTab', JSON.stringify(response.data));

      if(response.data.length > 0 && Array.isArray(response.data)){

        selTab = response.data[0];
        // console.log(selTab);
        setResthink1(selTab['resthink1']);
        setResthink2(selTab['resthink2']);
        setResthink3(selTab['resthink3']);
        setResthink4(selTab['resthink4']);
        setResthink5(selTab['resthink5']);

        setOffort(selTab['offort']);
        setFight(selTab['fight']);

        setg1_1(selTab['g1_1']);
        setg1_2(selTab['g1_2']);
        setg1_3(selTab['g1_3']);
        setg1_4(selTab['g1_4']);
        setg1_5(selTab['g1_5']);
        setg1_6(selTab['g1_6']);
        setg1_7(selTab['g1_7']);
        setg1_8(selTab['g1_8']);
        setg1_9(selTab['g1_9']);
        setg1_10(selTab['g1_10']);
        setg1_11(selTab['g1_11']);
        setg1_12(selTab['g1_12']);
        setg1_13(selTab['g1_13']);
        setg1_14(selTab['g1_14']);
        setg1_15(selTab['g1_15']);
        setg1_16(selTab['g1_16']);
        setg1_17(selTab['g1_17']);

        set_g1_1(selTab['_g1_1']);
        set_g1_2(selTab['_g1_2']);
        set_g1_3(selTab['_g1_3']);
        set_g1_4(selTab['_g1_4']);
        set_g1_5(selTab['_g1_5']);
        set_g1_6(selTab['_g1_6']);
        set_g1_7(selTab['_g1_7']);
        set_g1_8(selTab['_g1_8']);
        set_g1_9(selTab['_g1_9']);
        set_g1_10(selTab['_g1_10']);
        set_g1_11(selTab['_g1_11']);
        set_g1_12(selTab['_g1_12']);
        set_g1_13(selTab['_g1_13']);
        set_g1_14(selTab['_g1_14']);
        set_g1_15(selTab['_g1_15']);
        set_g1_16(selTab['_g1_16']);
        set_g1_17(selTab['_g1_17']);

        setg2_1(selTab['g2_1']);
        setg2_2(selTab['g2_2']);
        setg2_3(selTab['g2_3']);
        setg2_4(selTab['g2_4']);
        setg2_5(selTab['g2_5']);
        setg2_6(selTab['g2_6']);
        setg2_7(selTab['g2_7']);
        setg2_8(selTab['g2_8']);
        setg2_9(selTab['g2_9']);
        setg2_10(selTab['g2_10']);
        setg2_11(selTab['g2_11']);
        setg2_12(selTab['g2_12']);
        setg2_13(selTab['g2_13']);
        setg2_14(selTab['g2_14']);
        setg2_15(selTab['g2_15']);
        setg2_16(selTab['g2_16']);
        setg2_17(selTab['g2_17']);

        set_g2_1(selTab['_g2_1']);
        set_g2_2(selTab['_g2_2']);
        set_g2_3(selTab['_g2_3']);
        set_g2_4(selTab['_g2_4']);
        set_g2_5(selTab['_g2_5']);
        set_g2_6(selTab['_g2_6']);
        set_g2_7(selTab['_g2_7']);
        set_g2_8(selTab['_g2_8']);
        set_g2_9(selTab['_g2_9']);
        set_g2_10(selTab['_g2_10']);
        set_g2_11(selTab['_g2_11']);
        set_g2_12(selTab['_g2_12']);
        set_g2_13(selTab['_g2_13']);
        set_g2_14(selTab['_g2_14']);
        set_g2_15(selTab['_g2_15']);
        set_g2_16(selTab['_g2_16']);
        set_g2_17(selTab['_g2_17']);

        setg3_1(selTab['g3_1']);
        setg3_2(selTab['g3_2']);
        setg3_3(selTab['g3_3']);
        setg3_4(selTab['g3_4']);
        setg3_5(selTab['g3_5']);
        setg3_6(selTab['g3_6']);
        setg3_7(selTab['g3_7']);
        setg3_8(selTab['g3_8']);
        setg3_9(selTab['g3_9']);
        setg3_10(selTab['g3_10']);
        setg3_11(selTab['g3_11']);
        setg3_12(selTab['g3_12']);
        setg3_13(selTab['g3_13']);
        setg3_14(selTab['g3_14']);
        setg3_15(selTab['g3_15']);
        setg3_16(selTab['g3_16']);
        setg3_17(selTab['g3_17']);

        set_g3_1(selTab['_g3_1']);
        set_g3_2(selTab['_g3_2']);
        set_g3_3(selTab['_g3_3']);
        set_g3_4(selTab['_g3_4']);
        set_g3_5(selTab['_g3_5']);
        set_g3_6(selTab['_g3_6']);
        set_g3_7(selTab['_g3_7']);
        set_g3_8(selTab['_g3_8']);
        set_g3_9(selTab['_g3_9']);
        set_g3_10(selTab['_g3_10']);
        set_g3_11(selTab['_g3_11']);
        set_g3_12(selTab['_g3_12']);
        set_g3_13(selTab['_g3_13']);
        set_g3_14(selTab['_g3_14']);
        set_g3_15(selTab['_g3_15']);
        set_g3_16(selTab['_g3_16']);
        set_g3_17(selTab['_g3_17']);

        setImproved1(selTab['improved1']);
        setImproved2(selTab['improved2']);
        setImproved3(selTab['improved3']);
        setImproved4(selTab['improved4']);
        setImproved5(selTab['improved5']);

        setHowplay1(selTab['howplay1']);
        setHowplay2(selTab['howplay2']);
        setHowplay3(selTab['howplay3']);
        setHowplay4(selTab['howplay4']);
        setHowplay5(selTab['howplay5']);

        setMental1(selTab['mental1']);
        setMental2(selTab['mental2']);
        setMental3(selTab['mental3']);
        setMental4(selTab['mental4']);
        setMental5(selTab['mental5']);
        setMental6(selTab['mental6']);
        setMental7(selTab['mental7']);
        setMental8(selTab['mental8']);
        setMental9(selTab['mental9']);
        setMental10(selTab['mental10']);
        setMental11(selTab['mental11']);
        setMental12(selTab['mental12']);

        setRemark(selTab['remark']);

        setwin3(selTab['win3']);
        setwin1(selTab['win1']);
        setwin2(selTab['win2']);

        setlose1(selTab['lose1']);
        setlose2(selTab['lose2']);
        setlose3(selTab['lose3']);
      }
    });
    

  }, []);
  return (

    <>
      <Modal
            isOpen={isComModal}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal">
            {
              ff == 0 && (
                <>
                  <div className="col-12 p-2 mt-1 mx-0 text-center">
                    コメントテキスト
                  </div>
                  <div className="col-12 p-2 mx-0">
                    <textarea className="col-12 p-2" value={comment} style={{minHeight:'150px', borderWidth:'1px',borderRadius:'10px', resize:'none', borderColor:'#999'}} onChange={(event) => onChangeComment(event)}>{comment}</textarea>
                  </div>
                </>
              )
            }
            {
              ff == 1 && (
                <>
                  <div className="row col-12 px-0 mx-0 py-2 justify-content-center align-items-center border-bottom">
                    削除
                  </div>
                  <div className="row col-12 px-0 mx-0 py-4 justify-content-center align-items-center border-bottom">
                    本当に削除しますか？
                  </div>
                  <div className="col-12 px-0 mx-0 d-flex justify-content-between align-items-center">
                    <span className="col-6 py-2 px-0 d-flex justify-content-center align-items-center" onClick={(event) => closeModal()}>キャンセル</span>
                    <span className="col-6 py-2 px-0 d-flex justify-content-center align-items-center border-left" onClick={(event) => onRemoveSelItem(event)}>削除</span>
                  </div>
                </>
              )
            }
              
      </Modal>
      <div className="content pt-2 px-1 pb-0 coach-user-content">
        <NotificationAlert ref={notificationAlert}  className="col-12"/>
        <Row className="px-0 mx-0">          
          <Col className="col-12 px-0">
            <h6>{selTables.tournament}</h6>
            <Card className="card-user mb-0">              
              <CardBody>
                <Form>
                  <Row>                    
                    <Col className="col-8">                      
                        <h6>{selTables.think1}</h6>                                        
                    </Col> 
                    <Col className="col-4"> 
                      <select className="form-control" id="resthink1"
                          value={resthink1 == null ? '' : resthink1} 
                          onChange={getInputResthink1Value} 
                        >
                          <option value=""></option>
                          <option value="1">1/10</option>
                          <option value="2">2/10</option>
                          <option value="3">3/10</option>
                          <option value="4">4/10</option>
                          <option value="5">5/10</option>
                          <option value="6">6/10</option>
                          <option value="7">7/10</option>
                          <option value="8">8/10</option>
                          <option value="9">9/10</option>
                          <option value="10">10/10</option>
                        </select>
                    </Col>   
                  </Row>
                
                  <Row>                    
                    <Col className="col-8">                      
                        <h6>{selTables.think2}</h6>                                        
                    </Col> 
                    <Col className="col-4"> 
                      <select className="form-control" id="resthink2"
                          value={resthink2 == null ? '' : resthink2} 
                          onChange={getInputResthink2Value} 
                        >
                          <option value=""></option>
                          <option value="1">1/10</option>
                          <option value="2">2/10</option>
                          <option value="3">3/10</option>
                          <option value="4">4/10</option>
                          <option value="5">5/10</option>
                          <option value="6">6/10</option>
                          <option value="7">7/10</option>
                          <option value="8">8/10</option>
                          <option value="9">9/10</option>
                          <option value="10">10/10</option>
                        </select>
                    </Col>     
                  </Row>
                  <Row>                    
                    <Col className="col-8">                      
                        <h6>{selTables.think3}</h6>                                        
                    </Col> 
                    <Col className="col-4"> 
                      <select className="form-control" id="resthink3"
                          value={resthink3 == null ? '' : resthink3} 
                          onChange={getInputResthink3Value} 
                        >
                          <option value=""></option>
                          <option value="1">1/10</option>
                          <option value="2">2/10</option>
                          <option value="3">3/10</option>
                          <option value="4">4/10</option>
                          <option value="5">5/10</option>
                          <option value="6">6/10</option>
                          <option value="7">7/10</option>
                          <option value="8">8/10</option>
                          <option value="9">9/10</option>
                          <option value="10">10/10</option>
                        </select>
                    </Col>      
                  </Row>
                  <Row>                    
                    <Col className="col-8">                      
                        <h6>{selTables.think4}</h6>                                        
                    </Col> 
                    <Col className="col-4"> 
                      <select className="form-control" id="resthink4"
                          value={resthink4 == null ? '' : resthink4} 
                          onChange={getInputResthink4Value} 
                        >
                          <option value=""></option>
                          <option value="1">1/10</option>
                          <option value="2">2/10</option>
                          <option value="3">3/10</option>
                          <option value="4">4/10</option>
                          <option value="5">5/10</option>
                          <option value="6">6/10</option>
                          <option value="7">7/10</option>
                          <option value="8">8/10</option>
                          <option value="9">9/10</option>
                          <option value="10">10/10</option>
                        </select>
                    </Col>     
                  </Row>
                  <Row>                    
                    <Col className="col-8">                      
                        <h6>{selTables.think5}</h6>                                        
                    </Col> 
                    <Col className="col-4"> 
                      <select className="form-control" id="resthink5"
                           value={resthink5 == null ? '' : resthink5} 
                           onChange={getInputResthink5Value} 
                        >
                          <option value=""></option>
                          <option value="1">1/10</option>
                          <option value="2">2/10</option>
                          <option value="3">3/10</option>
                          <option value="4">4/10</option>
                          <option value="5">5/10</option>
                          <option value="6">6/10</option>
                          <option value="7">7/10</option>
                          <option value="8">8/10</option>
                          <option value="9">9/10</option>
                          <option value="10">10/10</option>
                        </select>
                    </Col>     
                  </Row>
                </Form>
              </CardBody>
            </Card>
            <Card className="card-user">              
              <CardBody>
                <Form>
                  <Row>                    
                    <Col className="col-8" style={{paddingTop:'10px'}}>                         
                        <h6>努力・闘志の自己評価</h6>                                        
                    </Col> 
                    <Col className="col-4"> 
                      <select className="form-control" id="offort"
                          value={offort == null ? '' : offort} 
                          onChange={getInputOffortValue} 
                        >
                          <option value=""></option>
                          <option value="1">1/10</option>
                          <option value="2">2/10</option>
                          <option value="3">3/10</option>
                          <option value="4">4/10</option>
                          <option value="5">5/10</option>
                          <option value="6">6/10</option>
                          <option value="7">7/10</option>
                          <option value="8">8/10</option>
                          <option value="9">9/10</option>
                          <option value="10">10/10</option>
                        </select>
                    </Col>   
                  </Row>
                
                  <Row>                    
                    <Col className="col-8" style={{paddingTop:'10px'}}>                      
                        <h6>プレーの自己評価</h6>                                        
                    </Col> 
                    <Col className="col-4"> 
                      <select className="form-control" id="fight"
                          value={fight == null ? '' : fight} 
                          onChange={getInputFightValue} 
                        >
                          <option value=""></option>
                          <option value="1">1/10</option>
                          <option value="2">2/10</option>
                          <option value="3">3/10</option>
                          <option value="4">4/10</option>
                          <option value="5">5/10</option>
                          <option value="6">6/10</option>
                          <option value="7">7/10</option>
                          <option value="8">8/10</option>
                          <option value="9">9/10</option>
                          <option value="10">10/10</option>
                        </select>
                    </Col>     
                  </Row>  

                   <Row>                    
                    <Col className="col-3" style={{paddingTop:'15px'}}>                         
                        <h6>試合結果</h6>                                        
                    </Col> 
                    <Col className="col-9" style={{paddingTop:'10px', color:'#FF0000'}}> 
                      <h5><b>{win1} - {lose1}、 {win2} - {lose2}、 {win3} - {lose3}</b></h5>
                    </Col>   
                  </Row>
                  <Row>                    
                    <Col className="col-12" style={{paddingTop:'15px'}}>                         
                        <h6>試合の流れ</h6>                                        
                    </Col>
                  </Row> 
                  <Row className="mx-0 px-0">                    
                    <Col className="col-12 px-0" style={{paddingTop:'15px', overflow:'auto'}}>                         
                      <table border='1' style={{width:'760px'}} onClick={(e) => onGameSetComment(e, 1)}>
                        <tbody>
                          <tr height="40px">
                            <td></td>
                            {
                              arrays.map((item, idx) =>
                                <td key={idx} className={(comlist['g1_'+item] || comlist['_g1_'+item]) ? 'impt':''}>{item==17 ? 'T' : item}</td>
                              )
                            }
                            <td style={{color:'#FF0000'}}><b>結果</b></td>
                          </tr>                       
                          <tr height="40px">
                            <td width="40px">自分</td>
                            {
                              arrays.map((item, idx) =>
                                <td width="40px" key={idx} id={"g1_"+item} 
                                  onTouchStart = {(event) => onEditSelectedItem(event, 'g1_'+item, 1)}  
                                  onMouseDown = {(event) => onEditSelectedItem1(event, 'g1_'+item, 1)} 
                                  onClick={(e) => handleOnChange(e, 'g1_'+item, 1)}>
                                  {eval('g1_'+item) == 1 ? (comlist['g1_'+item] ? <img src={redball} width="30px"/> : <img src={ball} width="30px"/>) : ''}
                                </td>
                              )
                            }   
                            <td style={{color:'#FF0000'}}><b>{win1}</b></td>                    
                          </tr>
                          <tr height="40px">
                            <td width="40px">相手</td>
                            {
                              arrays.map((item, idx) =>
                                <td width="40px" key={idx} id={"_g1_"+item} 
                                  onTouchStart = {(event) => onEditSelectedItem(event, '_g1_'+item, 1)}  
                                  onMouseDown = {(event) => onEditSelectedItem1(event, '_g1_'+item, 1)} 
                                  onClick={(e) => _handleOnChange(e, 'g1_'+item, 1)}>
                                  {eval('_g1_'+item) == 1 ? (comlist['_g1_'+item] ? <img src={redball} width="30px"/> : <img src={ball} width="30px"/>) : ''}
                                </td>
                              )
                            }  
                            <td style={{color:'#FF0000'}}><b>{lose1}</b></td>   
                          </tr>
                        </tbody>
                      </table>                             
                    </Col>
                  </Row> 
                  <Row className="mx-0 px-0">                    
                    <Col className="col-12 px-0" style={{paddingTop:'15px', overflow:'auto'}}>                         
                      <table border='1' style={{width:'760px'}} onClick={(e) => onGameSetComment(e, 2)}>
                        <tbody>
                          <tr height="40px">
                            <td></td>
                            {
                              arrays.map((item, idx) =>
                                <td key={idx} className={(comlist['g2_'+item] || comlist['_g2_'+item]) ? 'impt':''}>{item==17 ? 'T' : item}</td>
                              )
                            }
                            <td style={{color:'#FF0000'}}><b>結果</b></td>
                          </tr>                       
                          <tr height="40px">
                            <td width="40px">自分</td>
                            {
                              arrays.map((item, idx) =>
                                <td width="40px" key={idx} id={"g2_"+item} 
                                  onTouchStart = {(event) => onEditSelectedItem(event, 'g2_'+item, 1)}  
                                  onMouseDown = {(event) => onEditSelectedItem1(event, 'g2_'+item, 1)} 
                                  onClick={(e) => handleOnChange(e, 'g2_'+item, 2)}>
                                  {eval('g2_'+item) == 1 ? (comlist['g2_'+item] ? <img src={redball} width="30px"/> : <img src={ball} width="30px"/>) : ''}
                                </td>
                              )
                            }                       
                            <td style={{color:'#FF0000'}}><b>{win2}</b></td> 

                          </tr>
                          <tr height="40px">
                            <td width="40px">相手</td>
                            {
                              arrays.map((item, idx) =>
                                <td width="40px" key={idx} id={"_g2_"+item} 
                                  onTouchStart = {(event) => onEditSelectedItem(event, '_g2_'+item, 1)}  
                                  onMouseDown = {(event) => onEditSelectedItem1(event, '_g2_'+item, 1)} 
                                  onClick={(e) => _handleOnChange(e, 'g2_'+item, 2)}>
                                  {eval('_g2_'+item) == 1 ? (comlist['_g2_'+item] ? <img src={redball} width="30px"/> : <img src={ball} width="30px"/>) : ''}
                                </td>
                              )
                            }
                            <td style={{color:'#FF0000'}}><b>{lose2}</b></td>
                          </tr>
                        </tbody>
                      </table>                             
                    </Col>
                  </Row> 

                  <Row className="mx-0 px-0">                    
                    <Col className="col-12 px-0" style={{paddingTop:'15px', overflow:'auto'}}>                         
                      <table border='1' style={{width:'760px'}} onClick={(e) => onGameSetComment(e, 3)}>
                        <tbody>
                          <tr height="40px">
                            <td></td>
                            {
                              arrays.map((item, idx) =>
                                <td key={idx} className={(comlist['g3_'+item] || comlist['_g3_'+item]) ? 'impt':''}>{item==17 ? 'T' : item}</td>
                              )
                            }
                            <td style={{color:'#FF0000'}}><b>結果</b></td>
                          </tr>                       
                          <tr height="40px">
                            <td width="40px">自分</td>
                            {
                              arrays.map((item, idx) =>
                                <td width="40px" key={idx} id={"g3_"+item} 
                                  onTouchStart = {(event) => onEditSelectedItem(event, 'g3_'+item, 1)}  
                                  onMouseDown = {(event) => onEditSelectedItem1(event, 'g3_'+item, 1)} 
                                  onClick={(e) => handleOnChange(e, 'g3_'+item, 3)}>
                                  {eval('g3_'+item) == 1 ? (comlist['g3_'+item] ? <img src={redball} width="30px"/> : <img src={ball} width="30px"/>) : ''}
                                </td>
                              )
                            }                 
                            <td style={{color:'#FF0000'}}><b>{win3}</b></td>                         
                          </tr>
                          <tr height="40px">
                            <td width="40px">相手</td>
                            {
                              arrays.map((item, idx) =>
                                <td width="40px" key={idx} id={"_g3_"+item} 
                                  onTouchStart = {(event) => onEditSelectedItem(event, '_g3_'+item, 1)}  
                                  onMouseDown = {(event) => onEditSelectedItem1(event, '_g3_'+item, 1)} 
                                  onClick={(e) => _handleOnChange(e, 'g3_'+item, 3)}>
                                  {eval('_g3_'+item) == 1 ? (comlist['_g3_'+item] ? <img src={redball} width="30px"/> : <img src={ball} width="30px"/>) : ''}
                                </td>
                              )
                            }                          
                            <td style={{color:'#FF0000'}}><b>{lose3}</b></td>                        
                          </tr>
                        </tbody>
                      </table>                             
                    </Col>
                  </Row>             
                </Form>
                <Row className="pt-2">
                  <Col md="12"><h6>自由に記入欄</h6></Col>
                </Row>
                <Row>
                  <Col md="12">
                    <textarea className="form-control" id="remark" onChange={getInputRemarkValue} value={remark ? remark : ''}>{remark}</textarea>                          
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row>
                  <Col md="12">
                    <h6>{/*selTables.proposergroup*/} {selTables.opponentname}の{/*相手分析情報*/}分析情報</h6>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    {
                      checkboxgroup.map((group, num) =>
                      <Card className="demo-icons" key={num}>
                        <CardTitle tag="h6" style={{marginTop:'0.75rem'}}>{group.jp}</CardTitle>  
                        
                          {
                            eval(group.en).map((tmp, index) => 
                            
                            <Row key={index }>
                              <Col className="col-12" style={{color:'rgb(3, 115, 202)', fontSize:'14px'}}>
                                {/*<img src={questionImg}  width="20px"/>*/} {tmp.item}
                              </Col>
                              <Col className="col-12" style={{color:'#ff3d02', fontSize:'14px', paddingLeft:'40px'}}>
                               
                                <Input type="text" 
                                            style={{color:'#ff3d02', marginBottom:'5px'}}
                                            id={"an_"+num+"_" + index}
                                            name={"an_"+num}
                                            value={tmp.solution}                          
                                            onChange={(e) => analysisOnChange(e, index, group.en, group.fc)}
                                          />    
                              </Col>
                                                        
                            </Row>
                            
                            )
                          }                
                          
                      </Card>
                    )}
                    
                  </Col>
                </Row>
                <Row>                    
                  <Col className="col-6">
                    <input type="button" name="user" value="相手分析情報保存" className="btn-round btn btn-danger" onClick={save}/>
                  </Col>  
                  <Col className="col-6">
                    <input type="button" name="user" value="相手分析画面" className="btn-round btn btn-primary" onClick={profileUpdateFunc}/>
                  </Col>                                     
                </Row>
              </CardBody>
            </Card>   
            <Card>
              <CardBody>
                <Row>
                  <Col md="12"><h6>改善すべき内容</h6></Col>
                </Row>
                <Row>
                  <Col md="12">
                    <Input type="text" className="form-control" onChange={getInputImproved1Value} value={improved1 == null ? '' : improved1} style={{marginTop:'5px'}}/>
                    <Input type="text" className="form-control" onChange={getInputImproved2Value} value={improved2 == null ? '' : improved2} style={{marginTop:'5px'}}/>
                    <Input type="text" className="form-control" onChange={getInputImproved3Value} value={improved3 == null ? '' : improved3} style={{marginTop:'5px'}}/>
                    <Input type="text" className="form-control" onChange={getInputImproved4Value} value={improved4 == null ? '' : improved4} style={{marginTop:'5px'}}/>
                    <Input type="text" className="form-control" onChange={getInputImproved5Value} value={improved5 == null ? '' : improved5} style={{marginTop:'5px'}}/>                           
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row>
                  <Col md="12"><h6>再度同じ相手にあたるとしたら、どのようにプレーしますか？</h6></Col>
                </Row>
                <Row>
                  <Col md="12">
                    <Input type="text" className="form-control" onChange={getInputHowplay1Value} value={howplay1 == null ? '' : howplay1} style={{marginTop:'5px'}}/>
                    <Input type="text" className="form-control" onChange={getInputHowplay2Value} value={howplay2 == null ? '' : howplay2} style={{marginTop:'5px'}}/>
                    <Input type="text" className="form-control" onChange={getInputHowplay3Value} value={howplay3 == null ? '' : howplay3} style={{marginTop:'5px'}}/>
                    <Input type="text" className="form-control" onChange={getInputHowplay4Value} value={howplay4 == null ? '' : howplay4} style={{marginTop:'5px'}}/>
                    <Input type="text" className="form-control" onChange={getInputHowplay5Value} value={howplay5 == null ? '' : howplay5} style={{marginTop:'5px'}}/>                           
                  </Col>
                </Row>
              </CardBody>
            </Card>  
            <Card>
              <CardBody>
                <Row>
                  <Col md="12"><h6>試合後のメンタルチェック</h6></Col>
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>1. 最高のプレーができた</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental1 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental1Value(event, 1)}/>
                      <img src={face2} className={mental1 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental1Value(event, 2)} />
                      <img src={face3} className={mental1 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental1Value(event, 3)} />
                      <img src={face4} className={mental1 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental1Value(event, 4)} />
                      <img src={face5} className={mental1 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental1Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental1"
                                            value={mental1 == null ? '' : mental1} 
                                            onChange={getInputMental1Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col>  
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>最悪のプレーだった	</Col>
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>2. 体（筋肉）はリラックスしていた</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental2 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental2Value(event, 1)}/>
                      <img src={face2} className={mental2 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental2Value(event, 2)} />
                      <img src={face3} className={mental2 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental2Value(event, 3)} />
                      <img src={face4} className={mental2 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental2Value(event, 4)} />
                      <img src={face5} className={mental2 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental2Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental2"
                                            value={mental2 == null ? '' : mental2} 
                                            onChange={getInputMental2Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col>
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>体（筋肉）は緊張していた</Col>  
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>3. 不安はなかった</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental3 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental3Value(event, 1)}/>
                      <img src={face2} className={mental3 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental3Value(event, 2)} />
                      <img src={face3} className={mental3 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental3Value(event, 3)} />
                      <img src={face4} className={mental3 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental3Value(event, 4)} />
                      <img src={face5} className={mental3 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental3Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental3"
                                            value={mental3 == null ? '' : mental3} 
                                            onChange={getInputMental3Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col>
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>とても不安だった</Col>  
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>4. 落ち着いて冷静だった</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental4 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental4Value(event, 1)}/>
                      <img src={face2} className={mental4 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental4Value(event, 2)} />
                      <img src={face3} className={mental4 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental4Value(event, 3)} />
                      <img src={face4} className={mental4 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental4Value(event, 4)} />
                      <img src={face5} className={mental4 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental4Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental4"
                                            value={mental4 == null ? '' : mental4} 
                                            onChange={getInputMental4Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col>  
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>混乱し動揺していた</Col>
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>5. 積極的、楽観的な考え方をしていた</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental5 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental5Value(event, 1)}/>
                      <img src={face2} className={mental5 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental5Value(event, 2)} />
                      <img src={face3} className={mental5 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental5Value(event, 3)} />
                      <img src={face4} className={mental5 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental5Value(event, 4)} />
                      <img src={face5} className={mental5 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental5Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental5"
                                            value={mental5 == null ? '' : mental5} 
                                            onChange={getInputMental5Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col>  
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>消極的、悲観的な考えをしていた</Col>
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>6. 挑戦する事を楽しんでいた</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental6 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental6Value(event, 1)}/>
                      <img src={face2} className={mental6 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental6Value(event, 2)} />
                      <img src={face3} className={mental6 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental6Value(event, 3)} />
                      <img src={face4} className={mental6 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental6Value(event, 4)} />
                      <img src={face5} className={mental6 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental6Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental6"
                                            value={mental6 == null ? '' : mental6} 
                                            onChange={getInputMental6Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col> 
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>意欲やエネルギーが不足していた</Col>
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>7. 自動的、本能的にプレーしていた</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental7 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental7Value(event, 1)}/>
                      <img src={face2} className={mental7 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental7Value(event, 2)} />
                      <img src={face3} className={mental7 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental7Value(event, 3)} />
                      <img src={face4} className={mental7 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental7Value(event, 4)} />
                      <img src={face5} className={mental7 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental7Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental7"
                                            value={mental7 == null ? '' : mental7} 
                                            onChange={getInputMental7Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col>  
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>意識が先走って指図しすぎていた</Col>
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>8. プレーに集中できた</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental8 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental8Value(event, 1)}/>
                      <img src={face2} className={mental8 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental8Value(event, 2)} />
                      <img src={face3} className={mental8 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental8Value(event, 3)} />
                      <img src={face4} className={mental8 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental8Value(event, 4)} />
                      <img src={face5} className={mental8 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental8Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental8"
                                            value={mental8 == null ? '' : mental8} 
                                            onChange={getInputMental8Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col>  
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>集中していなかった</Col>
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>9. 注意力が鋭かった</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental9 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental9Value(event, 1)}/>
                      <img src={face2} className={mental9 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental9Value(event, 2)} />
                      <img src={face3} className={mental9 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental9Value(event, 3)} />
                      <img src={face4} className={mental9 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental9Value(event, 4)} />
                      <img src={face5} className={mental9 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental9Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental9"
                                            value={mental9 == null ? '' : mental9} 
                                            onChange={getInputMental9Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col> 
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>注意力が散漫だった</Col> 
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>10. ポジティブなエネルギーに満ちていた</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental10 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental10Value(event, 1)}/>
                      <img src={face2} className={mental10 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental10Value(event, 2)} />
                      <img src={face3} className={mental10 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental10Value(event, 3)} />
                      <img src={face4} className={mental10 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental10Value(event, 4)} />
                      <img src={face5} className={mental10 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental10Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental10"
                                            value={mental10 == null ? '' : mental10} 
                                            onChange={getInputMental10Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col>  
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>ネガティブなエネルギーだらけだった</Col>
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>11. 自信満々だった</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental11 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental11Value(event, 1)}/>
                      <img src={face2} className={mental11 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental11Value(event, 2)} />
                      <img src={face3} className={mental11 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental11Value(event, 3)} />
                      <img src={face4} className={mental11 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental11Value(event, 4)} />
                      <img src={face5} className={mental11 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental11Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental11"
                                            value={mental11 == null ? '' : mental11} 
                                            onChange={getInputMental11Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col> 
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>自信がなかった</Col> 
                </Row>
                <Row style={{borderBottom:'dotted 1px #ccc', padding:'3px'}} >
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>12. 自己コントロールができていた</Col>
                  <Col className="col-6 px-1" style={{display:'flex', alignItems:'center'}}> 
                    <div className="row col-12 px-0 py-2 mx-0 d-flex justify-content-between align-items-center">
                      <img src={face1} className={mental12 == 1 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental12Value(event, 1)}/>
                      <img src={face2} className={mental12 == 2 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental12Value(event, 2)} />
                      <img src={face3} className={mental12 == 3 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental12Value(event, 3)} />
                      <img src={face4} className={mental12 == 4 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental12Value(event, 4)} />
                      <img src={face5} className={mental12 == 5 ? 'c1_selected' : 'c1no_selected'} onClick={(event) => getInputMental12Value(event, 5)} />
                    </div>
                    {/*<select className="form-control" id="mental12"
                                            value={mental12 == null ? '' : mental12} 
                                            onChange={getInputMental12Value} 
                                          >
                                          <option value=""></option>
                                          <option value="1">1/5</option>
                                          <option value="2">2/5</option>
                                          <option value="3">3/5</option>
                                          <option value="4">4/5</option>
                                          <option value="5">5/5</option>
                                        </select>*/}
                  </Col>  
                  <Col className="col-3 px-1" style={{display:'flex', alignItems:'center'}}>自分をコントロールできなかった</Col>
                </Row>
              </CardBody>
            </Card>
            <Card className="demo-icons col-12" style={{padding:'10px'}}>
              <CardTitle tag="h6" style={{marginTop:'0.75rem'}}>コーチからのコメント</CardTitle>  
              <textarea className="form-control p-2" id="remark" readOnly="readonly" value={selTab.comment ? selTab.comment : ''} style={{background:'white'}}>{selTab.comment ? selTab.comment : ''}</textarea>
            </Card> 
            <Card className="mb-0">
              <CardBody>                
                <Row>                    
                    <Col className="px-1">
                      <input type="button" name="user" disabled={disabled} value="保存" className="btn-round btn btn-danger" onClick={(e) => tablesUpdateFunc(e, 0)}/>
                    </Col>    
                    <Col className="px-1">
                      <input type="button" name="user" disabled={disabled} value="送信" className="btn-round btn btn-primary" onClick={(e) => sendPreparationData(e, 1)}/>
                    </Col>    
                    {
                      selTables['id'] && (
                        <Col className="px-1">
                          <input type="button" disabled={disabled} name="user" value="削除" className="btn-round btn btn-primary" onClick={removeTablesData}/>
                        </Col>
                      )
                    }    
                    <Col className="px-1">
                    <input type="button" name="user" value="戻る" className="btn-round btn btn-primary" onClick={preparationPage}/>
                    </Col>                                  
                  </Row>
              </CardBody>
            </Card>       
          </Col>
        </Row>
      </div>
    </>
  );
}
function save(){

  let server = JSON.parse(window.sessionStorage.getItem(['s_serverData']));
  let serAry = [];
  for(var i = 0; i < server.length; i++){
    serAry[i] = {};
    serAry[i].id = server[i].id;
    serAry[i].solution = server[i].solution;
  }

  let receive = JSON.parse(window.sessionStorage.getItem(['s_receiveData']));
  let recAry = [];
  for(var i = 0; i < receive.length; i++){
    recAry[i] = {};
    recAry[i].id = receive[i].id;
    recAry[i].solution = receive[i].solution;
  }

  let stroke = JSON.parse(window.sessionStorage.getItem(['s_strokeData']));
  let strAry = [];
  for(var i = 0; i < stroke.length; i++){
    strAry[i] = {};
    strAry[i].id = stroke[i].id;
    strAry[i].solution = stroke[i].solution;
  }

  let netplay = JSON.parse(window.sessionStorage.getItem(['s_netplayData']));
  let netAry = [];
  for(var i = 0; i < netplay.length; i++){
    netAry[i] = {};
    netAry[i].id = netplay[i].id;
    netAry[i].solution = netplay[i].solution;
  }

  let mental = JSON.parse(window.sessionStorage.getItem(['s_mentalData']));
  let menAry = [];
  for(var i = 0; i < mental.length; i++){
    menAry[i] = {};
    menAry[i].id = mental[i].id;
    menAry[i].solution = mental[i].solution;
  }

  let tactics = JSON.parse(window.sessionStorage.getItem(['s_tacticsData']));
  let tacAry = [];
  for(var i = 0; i < tactics.length; i++){
    tacAry[i] = {};
    tacAry[i].id = tactics[i].id;
    tacAry[i].solution = tactics[i].solution;
  }

  axios.post(URL_API+"saveOtherSelAPI", {
    params: {
      s_serverData: JSON.stringify(serAry),
      s_receiveData: JSON.stringify(recAry), 
      s_strokeData: JSON.stringify(strAry),
      s_netplayData: JSON.stringify(netAry), 
      s_mentalData: JSON.stringify(menAry),
      s_tacticsData: JSON.stringify(tacAry), 
    }
  },{ 
    xsrfHeaderName: 'X-CSRF-Token',
    withCredentials: true
  })
  .then(function (response) {

  });
}

export default Tablesedit;
